import { useEffect, useState } from 'react';
import { Modal, Table, Button, Row, Col } from 'react-bootstrap';
import Swal from 'sweetalert2';
import api from '../../services/api';
import { vhostV1 } from '../funcoes';
import ModalAssociacao from './modalAssociacao';
import ModalCriarProduto from './modalCriarProduto';
import ModalSaveItens from './modalSaveItens';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Toolbar } from '@mui/material';


const ModalCheckAssociar = ({
    show,
    handleClose,
    cod_compra
}) => {


        const [file, setFile] = useState(null);
        const [sResult,setSresult] = useState(0);
        const [produtos,setProdutos] = useState([])
        const [cnpjEmitente,setCnpjEmitente] = useState('');
        const [razaoEmitente,setRazaoEmitente] = useState('');

        const [codCompra,setCodCompra] = useState('');
        const [chave,setChave] = useState('');
        const [itens, setItens] = useState([]);
        const [cidade, setCidade] = useState('');
        const [uf, setUf] = useState('');
        const [cep, setCep] = useState('');
        const [bairro, setBairro] = useState('');
        const [numero, setNumero] = useState('');
        const [codMunicipal, setCodMunicipal] = useState('');
        
         const [duplicata, setDuplicata] = useState([]);
         const [fatura, setFatura] = useState({});
         const [dataEmissao, setDataEmissao] = useState('');
         const [nProtocolo, setNProtocolo] = useState('');
    
         const [codFornecedor, setCodFornecedor] = useState(0);
    
         const [valorIcms, setValorIcms] = useState(0);
         const [valorBc, setValorBc] = useState(0);

   
         const [valorBcSt, setValorBcSt] = useState(0);
         const [valorSt, setValorSt] = useState(0);

         const [valorProd, setValorProd] = useState(0);
         const [valorFrete, setValorFrete] = useState(0);
         const [valorSeg, setValorSeg] = useState(0);
         const [valorDesc, setValorDesc] = useState(0);

         const [valorIpi, setValorIpi] = useState(0);

         const [valorOutros, setValorOutros] = useState(0);
         const [valorNotaFiscal, setValorNotaFiscal] = useState(0);
         const [sucesso, setSucesso] = useState("N");

         const [numeroNF, setNumeroNF] = useState(0);




    const [currentIndex, setCurrentIndex] = useState(0);
    const [verificando, setVerificando] = useState(false);
    const [isModalAssociacaoOpen,setIsModalAssociacaoOpen] = useState(false);
    const [isModalAddOpen,setIsModalAddOpen] = useState(false); 
    const [produtoParaAssociar, setProdutoParaAssociar] = useState(null);
    const [checkImport, setCheckImport] = useState(false);  
    const [showModal, setShowModal] = useState(false);

    const [msgErro, setMsgErro] = useState('');
    const [erroValidacao,setErrovalidacao] = useState(false);

    const [chaveNfe, setChaveNfe] = useState('');
    const [erroChave, setErroChave] = useState('');

   

    function openModalAssociacao(produto){      
        setProdutoParaAssociar(produto);
        setIsModalAssociacaoOpen(true);
     }
    
     function closeModalAssociacao(){
      setIsModalAssociacaoOpen(false);
        setProdutoParaAssociar(null);
        startVerificacao();
        handleUpload();
     }

    

     function openModalAdd(produto){
        setProdutoParaAssociar(produto);
        setIsModalAddOpen(true);
     }
     function closeModalAdd(){
        setProdutoParaAssociar(null);
        setIsModalAddOpen(false);
        handleUpload();
     }

    const config = {
        headers: {
            'Authorization': localStorage.getItem("token")
        }
    };

    const confirmClose = () => {
        setSucesso("N");
        handleClose();       
    }

    
    function converterData(data) {
         
        const [ano, mes, dia] = data.split('-');
        
        
        return `${dia}/${mes}/${ano}`;
      }

    function aplicaRegras() {
        const cstMap = {
            1: 50,
            2: 50,
            3: 50,
            4: 50,
            5: 50,
            6: 50,
            7: 70,
            8: 74,
            9: 72,
            49: 99
        };
    
        setProdutos(prevProdutos => {
            const updatedProdutos = prevProdutos.map(produto => {
                const pisCst = produto?.IMPOSTOS?.PIS?.CST;
                const cofinsCst = produto?.IMPOSTOS?.COFINS?.CST;
               
    
                
    
                let updatedProduto = { ...produto };
    
                if (pisCst in cstMap) {
                    updatedProduto.IMPOSTOS = {
                        ...updatedProduto.IMPOSTOS,
                        PIS: {
                            ...updatedProduto.IMPOSTOS?.PIS,
                            CST: cstMap[pisCst]
                        }
                    };
                }
    
                if (cofinsCst in cstMap) {
                    updatedProduto.IMPOSTOS = {
                        ...updatedProduto.IMPOSTOS,
                        COFINS: {
                            ...updatedProduto.IMPOSTOS?.COFINS,
                            CST: cstMap[cofinsCst]
                        }
                    };
                }
    
                
    
                return updatedProduto;
            });
    
            return updatedProdutos;
        });
    }
    
    const validarChave = (chave) => {
  if (!chave) return 'Informe a chave';

  const limpa = chave.replace(/\D/g, '');

  if (limpa.length !== 44) {
    return 'A chave deve ter 44 dígitos';
  }

  return '';
};

const buscarXmlPorChave = async () => {
  const erro = validarChave(chaveNfe);
  if (erro) {
    setErroChave(erro);
    return;
  }

  try {
    setErroChave('');

    const chaveLimpa = chaveNfe.replace(/\D/g, '');

    const res = await api.post(
      vhostV1(`webcash/nfe/baixarXmlUni/${chaveLimpa}`),
      {},
      config
    );

    console.log(res);
    
    const base64 = res.data.data.xml_base64;

    if (!base64) {
      setErroChave('XML não encontrado para essa chave');
      return;
    }

    // reaproveita sua função
    enviaXml(base64);

  } catch (err) {
    setErroChave('Erro ao buscar XML');
  }
};


    const handleSaveProduto = (produtoEditado) => {
        const novosProdutos = [...produtos];
        novosProdutos[currentIndex] = produtoEditado;
        setProdutos(novosProdutos);

        if (currentIndex < produtos.length - 1) {
            setCurrentIndex(currentIndex + 1); 
        } else {
            setShowModal(false); 
            salvaMovCompraManual(novosProdutos); 
        }
    };

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        // setChave(selectedFile.name)
        setFile(selectedFile);
        
    };


    const handleUpload = () => {
            if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                const base64Data = reader.result.split(',')[1]; 
                // Envie o base64Data aqui
                enviaXml(base64Data);
               
                
                        
            };
            reader.readAsDataURL(file);
            }
        };
    
    
        async function enviaXml(sXml){
           
           
            
            let response = {};
            try {
              response = await api.post(vhostV1('webcash/compras/xml'),{
                COD_COMPRA: String(cod_compra),
                xmlBase64:sXml
                
              }, config)
    
              console.log(response);

            //   if(response.response.data.result === 0){
            //     setMsgErro(response.response.data.erro);
            //   setErrovalidacao(true);
            // }
              
              if(response.data.dados.fornecedor !== null){
                setCnpjEmitente(response.data.dados.fornecedor.cnpj);          
                setRazaoEmitente(response.data.dados.fornecedor.nome); 
                setCodFornecedor(response.data.dados.fornecedor.codigoFornecedor);          
                }
    
               
              if(response.data.dados.endereco !== null){
                  setCidade(response.data.dados.endereco.nomeMunicipio);
                  setUf(response.data.dados.endereco.uf);
                  setCep(response.data.dados.endereco.cep);
                  setBairro(response.data.dados.endereco.bairro);
                  setNumero(response.data.dados.endereco.numero);
                  setCodMunicipal(response.data.dados.endereco.codigoMunicipal);
                    }  
    
              if(response.data.dados.itens !== null){
               setItens(response.data.dados.itens);  
               setProdutos(response.data.dados.itens);
                   }  
                   
              if(response.data.dados.cobr !== null){
                   setDuplicata(response.data.dados.cobr.dup);
                   setFatura(response.data.dados.cobr.fat); 

                  }
                        
                        
              if(response.data.dados.nfe !== null){         
               setNumeroNF(response.data.dados.nfe.nNF);
               setDataEmissao(response.data.dados.nfe.dataEmissao);          
               setChave(response.data.dados.nfe.chaveNFe);
               setNProtocolo(response.data.dados.nfe.numeroDeProtocolo);           
                      }
    
               if(response.data.dados.cabecalho !== null){
                setValorBc(response.data.dados.cabecalho.ICMSTot.vBC);
                setValorIcms(response.data.dados.cabecalho.ICMSTot.vICMS);        
                   setValorBcSt(response.data.dados.cabecalho.ICMSTot.vBCST);
                   setValorSt(response.data.dados.cabecalho.ICMSTot.vST);        
                   setValorProd(response.data.dados.cabecalho.ICMSTot.vProd);
                   setValorFrete(response.data.dados.cabecalho.ICMSTot.vFrete);
                   setValorSeg(response.data.dados.cabecalho.ICMSTot.vSeg);
                   setValorDesc(response.data.dados.cabecalho.ICMSTot.vDesc);       
                   setValorIpi(response.data.dados.cabecalho.ICMSTot.vIPI);
                   setValorOutros(response.data.dados.cabecalho.ICMSTot.vOutro);
                   setValorNotaFiscal(response.data.dados.cabecalho.ICMSTot.vNF);
                     }
                          
    
              setSresult(1);
         
             
              
             aplicaRegras();
            
    
            } catch (error) {
              
              console.error('Erro ao enviar o XML:', error);          
            }
             
                   
          
          }
   

    function salvaMovCompraAuto(){
        console.log("Salvando...");
        
        const sJson = {
            COD_COMPRA : cod_compra,
            itens: produtos,
            colaborador: localStorage.getItem("colaborador"),
            cabecalho: {
                vICMS: valorIcms,
                vBC: valorBc,
                vBCST: valorBcSt,
                vST: valorSt,
                vProd: valorProd,
                vFrete: valorFrete,
                vSeg: valorSeg,
                vDesc: valorDesc,
                vIPI: valorIpi,
                vOutro: valorOutros,
                vNF: valorNotaFiscal
            },
            fornecedor: {
                cnpj: cnpjEmitente,
                nome: razaoEmitente,
                codigoFornecedor: codFornecedor
            },
            endereco: {
                nomeMunicipio: cidade,
                uf: uf,
                cep: cep,
                bairro: bairro,
                numero: numero,
                codigoMunicipal: codMunicipal
            },
            cobr: {
                dup: duplicata,
                fat: fatura
            },
            nfe: {
                nNF: numeroNF,
                dataEmissao: dataEmissao,
                chaveNFe: chave,
                numeroDeProtocolo: nProtocolo
            }
        } 


        for (let produto of produtos) {
            if (!produto.hasOwnProperty('RELACAO')) {
                setMsgErro(`Produto "${produto.DESCRICAO}" não está associado`);
                setErrovalidacao(true); 
                return; 
            }
        }

        api.post(vhostV1('webcash/compras/inserir/produto'),sJson,config)
        .then((response) => {
            console.log(response);
            
            
            
                console.log("Salvo com sucesso!");
                setSucesso("S")
                
                
            
        }).catch((error) => {
            console.log(error);
        });
    }




    function salvaMovCompraManual(produtosAtt){
        const sJson = {
            COD_COMPRA : cod_compra,
            colaborador: localStorage.getItem("colaborador"),
            itens: produtosAtt,
            cabecalho: {
                vICMS: valorIcms,
                vBC: valorBc,
                vBCST: valorBcSt,
                vST: valorSt,
                vProd: valorProd,
                vFrete: valorFrete,
                vSeg: valorSeg,
                vDesc: valorDesc,
                vIPI: valorIpi,
                vOutro: valorOutros,
                vNF: valorNotaFiscal
            },
            fornecedor: {
                cnpj: cnpjEmitente,
                nome: razaoEmitente,
                codigoFornecedor: codFornecedor
            },
            endereco: {
                nomeMunicipio: cidade,
                uf: uf,
                cep: cep,
                bairro: bairro,
                numero: numero,
                codigoMunicipal: codMunicipal
            },
            cobr: {
                dup: duplicata,
                fat: fatura
            },
            nfe: {
                nNF: numeroNF,
                dataEmissao: dataEmissao,
                chaveNFe: chave,
                numeroDeProtocolo: nProtocolo
            }
        }

        for (let produto of produtos) {
            if (!produto.hasOwnProperty('RELACAO')) {
                setMsgErro(`Produto "${produto.DESCRICAO}" não está associado`);
                setErrovalidacao(true); 
                return; 
            }
        }
        api.post(vhostV1('webcash/compras/inserir/produto'),sJson,config)
        .then((response) => {
            console.log(response.data.result);
            if(response.data.result === 1){
                console.log("Salvo com sucesso!");
                
                setSucesso("S");
                
            }
        }).catch((error) => {
            console.error(error);
        });
    }


    const startVerificacao = () => {
        if (produtos?.length > 0) {
            setCurrentIndex(0);
            setVerificando(true);
        }
    };

    
    useEffect(() => {
        if (show && produtos?.length > 0) {
            startVerificacao();
        }
    }, [show]);

   
   

    return (
        <div>
           
            <ModalAssociacao
                isOpen={isModalAssociacaoOpen}
                onRequestClose={closeModalAssociacao}
                prodAssociar={produtoParaAssociar?.EAN}
                codProduto={produtoParaAssociar?.EAN}
                produtos={produtoParaAssociar || {}}
                cod_fornecedor={codFornecedor}
                QTD_EMBALAGEM={produtoParaAssociar?.QUANTIDADE_EMBALAGEM}
                unidade={produtoParaAssociar?.UNIDADE}
                cod_produto_fornecedor={produtoParaAssociar?.COD_PRODUTO_FORNECEDOR}
            />
            <ModalCriarProduto
                tag={1}
                QTD_EMBALAGEM={produtoParaAssociar?.QUANTIDADE_EMBALAGEM}
                cod_fornecedor={produtoParaAssociar?.COD_PRODUTO_FORNECEDOR}
                cod_ean={produtoParaAssociar?.EAN}
                isOpen={isModalAddOpen}
                descricaoProd={produtoParaAssociar?.DESCRICAO}
                ncmProd={produtoParaAssociar?.NCM}                
                onRequestClose={closeModalAdd}
                cod_compra={cod_compra}
                produto={produtoParaAssociar}
            />

            {showModal && (
                <ModalSaveItens
                    show={showModal}
                    item={produtos[currentIndex]}
                    onSave={handleSaveProduto}
                    handleClose={() => setShowModal(false)}
                />
            )}
            <Modal show={show} onHide={handleClose} size="xl">
               <Modal.Header closeButton>
  <div className="row importacao w-100 mt-5">

    {/* Título */}
    <div className="col-12 mb-2">
      <Modal.Title>Verificar Produtos</Modal.Title>
    </div>

    {/* Upload XML */}
    <div className="col-md-6 d-flex align-items-center gap-2">
      <input
        type="file"
        accept=".xml"
        onChange={handleFileChange}
      />
      <button
        onClick={handleUpload}
        className="btn btn-secondary"
      >
        Importar XML
      </button>
    </div>

    {/* Chave de acesso */}
    <div className="col-md-6">
      <div className="d-flex gap-2">
        <input
          type="text"
          className="form-control"
          placeholder="Digite a chave de acesso (44 dígitos)"
          value={chaveNfe}
          onChange={(e) => {
            setChaveNfe(e.target.value);
            setErroChave('');
          }}
        />

        <button
          onClick={buscarXmlPorChave}
          className="btn btn-primary"
        >
          Buscar
        </button>
      </div>

      {erroChave && (
        <small className="text-danger">{erroChave}</small>
      )}
    </div>

  </div>
</Modal.Header>
                <Modal.Body>
                    <h5>Dados da Nota</h5>
                    <Row className="mb-3">
                        <Col><strong>Fornecedor:</strong> {razaoEmitente}</Col>
                        <Col><strong>Código Fornecedor:</strong> {codFornecedor}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col><strong>Data de Emissão:</strong> {new Date(dataEmissao).toLocaleDateString('pt-BR')}</Col>
                        <Col><strong>BC ICMS:</strong> {Number(valorBc).toLocaleString("pt-br", { style: "currency", currency: "BRL" })}</Col>
                        <Col><strong>ICMS:</strong> {Number(valorIcms).toLocaleString("pt-br", { style: "currency", currency: "BRL" })}</Col>
                        <Col><strong>BC ST:</strong>{Number(valorBcSt).toLocaleString("pt-br", {style: "currency", currency: "BRL"})}</Col>
                        <Col><strong>VALOR ST:</strong> {Number(valorSt).toLocaleString("pt-br", { style: "currency", currency: "BRL" })}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col><strong>Valor dos Produtos:</strong>{Number(valorProd).toLocaleString("pt-br", {style: 'currency', currency: "BRL"})}</Col>
                        <Col><strong>Frete:</strong> {Number(valorFrete).toLocaleString("pt-br", { style: "currency", currency: "BRL" })}</Col>
                        <Col><strong>Outras Despesas:</strong> {Number(valorOutros).toLocaleString("pt-br", { style: "currency", currency: "BRL" })}</Col>
                        <Col><strong>Total Nota:</strong> {Number(valorNotaFiscal).toLocaleString("pt-br", { style: "currency", currency: "BRL" })}</Col>
                    </Row>

                    <hr />

                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Ações</th>
                                <th>Código Fornecedor</th>
                                <th>Nome</th>
                                <th>Ean</th>
                                <th>Cfop</th>
                                <th>Ncm</th>
                                <th>Unidade</th>
                                <th>Qtd</th>
                                <th>Compra</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {produtos?.map((produto, index) => (
                                <tr key={produto.COD_PRODUTO_FORNECEDOR} className={index === currentIndex ? 'table-active' : ''}>
                                    <td>
                                       {!produto.RELACAO && ( 
                                        <div className="dropdown">
                                            <button
                                                className="btn btn-outline-secondary dropdown-toggle"
                                                type="button"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >
                                                Opções
                                            </button>
                                            <ul className="dropdown-menu">
                                                {!produto.RELACAO && (
                                                    <li>
                                                        <a
                                                            className="dropdown-item"
                                                            onClick={() => openModalAssociacao(produto)}
                                                        >
                                                            <i className="bi bi-card-checklist"></i> Associar
                                                        </a>
                                                    </li>
                                                )}
                                                
                                                    <li>
                                                        <a
                                                            className="dropdown-item"
                                                            onClick={() => openModalAdd(produto)}
                                                        >
                                                            <i className="bi bi-plus-circle"></i> Adicionar
                                                        </a>
                                                    </li>
                                                
                                            </ul>
                                        </div>
                                    )}
                                    </td>
                                    <td>{produto.COD_PRODUTO_FORNECEDOR}</td>
                                    <td>{produto.DESCRICAO}</td>
                                    <td>{produto.EAN}</td>
                                    <td>{produto.CFOP}</td>
                                    <td>{produto.NCM}</td>
                                    <td>{produto.UNIDADE}</td>
                                    <td>{produto.QTD}</td>
                                    <td>{Number(produto.COMPRA).toLocaleString("pt-br", { style: "currency", currency: "BRL" })}</td>
                                    <td>{Number(produto.TOTAL).toLocaleString("pt-br", { style: "currency", currency: "BRL" })}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    <h5 className="mt-4">Duplicatas</h5>
                    <div className='row d-flex'>
                     {duplicata?.map((dup) => (
                    <div key={dup.nDup} className="mb-3">
                        <div className="col-12 d-flex">       
                     <input className="form-control col-3 mr-2" value={`Duplicata ${dup.nDup}`} readOnly/>
                     <input type="text" className="form-control mb-2 mr-3 col-3" value={`Vencimento: ${converterData(dup.dVenc)}`} readOnly />
                     <input type="text" className="form-control col-3" value={`Valor: R$ ${Number(dup.vDup).toLocaleString("pt-br", { style: "currency", currency: "BRL" })}`} readOnly />
                    </div>
                    </div>
                    ))}
                   </div>
                   
                   
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex align-items-center mr-2">
                        <input
                            type="checkbox"
                            checked={checkImport}
                            onChange={(e) => setCheckImport(e.target.checked)}
                            className="mr-2"
                        />
                        <label className='form-check-label'>Desativar Importação Automática</label>
                    </div>
                    <Button variant="danger" onClick={handleClose}>
                        Fechar
                    </Button>
                    {
                        checkImport ? 
                        <Button variant="success" onClick={(e) => setShowModal(true)}>
                            Importar Nota
                            </Button>
                            : 
                            <Button variant="success" onClick={salvaMovCompraAuto}>
                                Salvar Nota
                            </Button>
                        
                    }
                    
                </Modal.Footer>
            </Modal>

            {
                       sucesso === "S" ? 
                       <SweetAlert
                          success                         
                          confirmBtnText="OK"
                          confirmBtnBsStyle="success"
                          title="Parabéns"
                          onConfirm={() => confirmClose()}                            
                        >
                          Nota Salva com sucesso!
                        </SweetAlert>:null
                       
                      }

             {
                       erroValidacao ? 
                       <SweetAlert
                          danger
                          confirmBtnText="OK"
                          confirmBtnBsStyle="danger"
                          title="Erro"
                          onConfirm={() => setErrovalidacao(false)}                            
                        >
                          {msgErro}
                        </SweetAlert>:null
                       
                      }          
        </div>
    );
};

export default ModalCheckAssociar;